import { render, staticRenderFns } from "./BuyingStationDetails.vue?vue&type=template&id=1f78575f&scoped=true"
import script from "./BuyingStationDetails.vue?vue&type=script&lang=js"
export * from "./BuyingStationDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyingStationDetails.vue?vue&type=style&index=0&id=1f78575f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78575f",
  null
  
)

export default component.exports